module.exports = new __parcel__URL__("target-3696.0c12b623.png").toString();